import { render, staticRenderFns } from "./secondadd.vue?vue&type=template&id=44b4eeaf&scoped=true&"
import script from "./secondadd.vue?vue&type=script&lang=js&"
export * from "./secondadd.vue?vue&type=script&lang=js&"
import style0 from "./secondadd.vue?vue&type=style&index=0&id=44b4eeaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b4eeaf",
  null
  
)

export default component.exports